// import '../../styles/blocks/extended-carousel.scss';

import Swiper, { Pagination, Thumbs, Navigation, Autoplay, A11y } from 'swiper';

Swiper.use([Pagination, Thumbs, Navigation, Autoplay, A11y ]);

let swiper;

if(document.querySelector('.extended-swiper')) {
    swiper = new Swiper('.extended-swiper', {
        allowTouchMove: false,
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
            type: 'custom',
            renderCustom: function (swiper, current, total) {
                var content = document.querySelectorAll('.swiper-pagination-html')[current-1];
                if(content) {
                    return content.innerHTML;
                }
            },
        },
    });
}

// Pausar autoplay om användaren har focus innuti karusellen
document.querySelector('.extended-swiper').querySelectorAll('*').forEach(item => {
    item.addEventListener('focus', e => {
        swiper.autoplay.stop()
    });
})
